import { render, staticRenderFns } from "./JobActivityAdd.vue?vue&type=template&id=505655ba&scoped=true"
import script from "./JobActivityAdd.vue?vue&type=script&lang=js"
export * from "./JobActivityAdd.vue?vue&type=script&lang=js"
import style0 from "./JobActivityAdd.vue?vue&type=style&index=0&id=505655ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505655ba",
  null
  
)

export default component.exports